module.exports = __webpack_public_path__ + "static/img/3-2.9b6e77d.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/service/3-2.png
// module id = fPeO
// module chunks = 1